export default {
  state: {
    qa: [],
  },
  getters: {
    "llm/qa/get": (state) => {
      console.log(state.qa);
      return state.qa;
    },
  },
  mutations: {
    "llm/qa/set": function (state, data) {
      state.qa = data;
    },
  },
  actions: {
    "llm/qa/get": async function ({ commit, dispatch }, { botID }) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_rag.get(`/qa/${botID}`);
        dispatch("setLoader", false);
        commit("llm/qa/set", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    "llm/qa/getOne": async function ({ dispatch }, { id, botID }) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_rag.get(`/qa/${botID}/${id}`);
        dispatch("setLoader", false);
        return data;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
      }
    },
    "llm/qa/add": async function ({ dispatch }, { botID, data }) {
      try {
        dispatch("setLoader", true);
        const { res } = await this._vm.$http_rag.post(`/qa/${botID}`, data);
        dispatch("setLoader", false);
        return res;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
      }
    },
    "llm/qa/update": async function ({ dispatch }, { botID, id, data }) {
      try {
        dispatch("setLoader", true);
        const { res } = await this._vm.$http_rag.put(
          `/qa/${botID}/${id}`,
          data
        );
        dispatch("setLoader", false);
        return res;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
      }
    },
    "llm/qa/delete": async function ({ dispatch }, { id, botID }) {
      try {
        dispatch("setLoader", true);
        const { res } = await this._vm.$http_rag.delete(`/qa/${botID}/${id}`);
        dispatch("setLoader", false);
        return res;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
      }
    },
  },
};
